import Project from '../Project/Project'

function ProjectList({ projects }) {
    return (
        <div className='list'>
            { projects.map(project => <Project key={ project.id } { ...project } />) }
        </div>
    )
}

export default ProjectList